import React, { useEffect, useRef, useState } from "react";
import { baseUrl } from '../../config.js'
import { Link, useNavigate } from 'react-router-dom'
import useToken from '../../useToken';

import './Host.css';

import Agregar from '../../img/Agregar.png';
import Moral from '../../img/moral.png';
import Física from '../../img/fisica.png';
import SinEmpresa from '../../img/sinempresa.png';
import Editar from '../../img/editar.png';
import defaultAlmacen from '../../img/defaultAlmacen.png';

const Host = ({selectAlmacen})=>{
	
	const {token} = useToken();
	const navigate = useNavigate();
	const [personas, setPersonas] = useState([]);
	const [almacenes, setAlamcenes] = useState([]);
	const [selected, setSelected] = useState(null);
	const [cantidades, setCantidades] = useState({});
	const [filtros, setFiltros] = useState({});
	const [vistaLista, setVistaLista] = useState(false);

	useEffect(()=>{
		if(token)
            getData();
	}, [token])

	const getData = async ()=>{
		console.log(token)
		const result = await fetch(baseUrl+"User/Companies/",{
			headers:{
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		setPersonas(result?.data || []);

		const result1 = await fetch(baseUrl+"Stores/User/",{
			headers:{
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			}
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
		if(result1?.success){
			setAlamcenes(result1.data || []);
		}
	}

	useEffect(()=>{
		const aux = {activos:0, proceso:0}
		almacenes.forEach(almacen => {
			aux[almacen.idCompany || 0] = aux[almacen.idCompany || 0]*1+1 || 1;
		});
		console.log(aux);

		personas?.forEach(persona=>{
			if(persona.approved)
				aux["activos"]++;
			else
				aux["proceso"]++;
		})

		setCantidades({...aux});
	}, [personas, almacenes])
	if(selectAlmacen)
		return(
	
			<div className="personas">
				<h2>Selecciona el Almacén</h2>
				<div className="hostAlmacenes">
					{almacenes.map(almacen=>{
						if(selected === null || almacen.idCompany == selected)
						return(
							<Link to={'/host/publicaciones/'+almacen.idStore+'/nueva'} key={almacen.idStore}>
								<div className="imgAlmacen">
									{almacen?.Photos.length!=0 && almacen?.Photos[0] &&
										<img src={almacen?.Photos[0].url}/>
									}
									{almacen?.Photos.length === 0 &&
										<img src={defaultAlmacen}/>
									}
								</div>
								<div className="nombreAlmacen">{almacen.name}</div>
							</Link>
						)
					})
					}
				</div>
			</div>
		)
	else
		return(
			<div className="personas-container">
				<div className="personas-header">
					<div className="filter-section">
						<div className="view-toggle">
							<button 
								className={!vistaLista ? 'active' : ''} 
								onClick={() => setVistaLista(false)}
								title="Vista de cuadrícula"
							>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
									<rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
									<rect x="11" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
									<rect x="2" y="11" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
									<rect x="11" y="11" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
								</svg>
							</button>
							<button 
								className={vistaLista ? 'active' : ''} 
								onClick={() => setVistaLista(true)}
								title="Vista de lista"
							>
								<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
									<path d="M6 4H16M6 9H16M6 14H16M2 4H3M2 9H3M2 14H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
								</svg>
							</button>
						</div>
						<div className="filter-pills">
							<button
								className={`filter-pill ${filtros?.status == undefined ? 'active' : ''}`}
								onClick={()=>{
									setFiltros({...filtros, status: undefined});
								}}
							>
								<span className="filter-label">Todos</span>
								<span className="filter-count">{personas?.length || 0}</span>
							</button>
							<button
								className={`filter-pill ${filtros?.status == 'activos' ? 'active' : ''}`}
								onClick={()=>{
									setFiltros({...filtros, status: 'activos'});
								}}
							>
								<span className="filter-label">Activos</span>
								<span className="filter-count">{cantidades?.activos || 0}</span>
							</button>
							<button
								className={`filter-pill ${filtros?.status == 'proceso' ? 'active' : ''}`}
								onClick={()=>{
									setFiltros({...filtros, status: 'proceso'});
								}}
							>
								<span className="filter-label">En Proceso</span>
								<span className="filter-count">{cantidades?.proceso || 0}</span>
							</button>
						</div>
					</div>
					<Link data-tour="btn-agregar-empresa" className="btn-agregar-empresa" to='/host/gestion/personas/nueva'>
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
						</svg>
						<span>Agregar Empresa/Persona</span>
					</Link>
				</div>

				<div className={vistaLista ? "personas-list" : "personas-grid"}>
					{personas?.map(persona=>{
						if(!filtros.status || (filtros.status == 'activos' && persona.approved) || (filtros.status == 'proceso' && !persona.approved))
						return vistaLista ? (
							<div className="empresa-list-item" key={persona.idCompany}>
								<Link to={'/host/gestion/personas/'+persona.idCompany} className="empresa-list-link">
									<div className="empresa-list-icon">
										{!persona.url &&
											<img src={persona.idtypeCompany == 1 ? Física : Moral} alt={persona.idtypeCompany == 1 ? 'Persona Física' : 'Persona Moral'}/>
										}
										{persona.url &&
											<img src={persona.url} alt={persona.name}/>
										}
									</div>
									<div className="empresa-list-info">
										<h3 className="empresa-list-nombre">{persona.name}</h3>
										<p className="empresa-list-rfc">{persona.RFC}</p>
									</div>
								</Link>
								<div className="empresa-list-actions">
									{cantidades[persona.idCompany] && cantidades[persona.idCompany] != 0 &&
										<Link to={'/host/gestion/personas/'+persona.idCompany+'/almacenes'} className="btn-almacenes">
											Ver Almacenes({cantidades[persona.idCompany]})
										</Link>
									}
									{(!cantidades[persona.idCompany] || cantidades[persona.idCompany] == 0) &&
										<Link to={'/host/gestion/personas/'+persona.idCompany+'/almacenes/nuevo'} className="btn-almacenes">
											Agregar Almacén
										</Link>
									}
								</div>
							</div>
						) : (
							<div className="empresa-card" key={persona.idCompany}>
								<Link to={'/host/gestion/personas/'+persona.idCompany} className="empresa-card-link">
									<div className="empresa-icon">
										{!persona.url &&
											<img src={persona.idtypeCompany == 1 ? Física : Moral} alt={persona.idtypeCompany == 1 ? 'Persona Física' : 'Persona Moral'}/>
										}
										{persona.url &&
											<img src={persona.url} alt={persona.name}/>
										}
									</div>
									<div className="empresa-info">
										<h3 className="empresa-nombre">{persona.name}</h3>
										<p className="empresa-rfc">{persona.RFC}</p>
									</div>
								</Link>
								<div className="empresa-actions">
									{cantidades[persona.idCompany] && cantidades[persona.idCompany] != 0 &&
										<Link to={'/host/gestion/personas/'+persona.idCompany+'/almacenes'} className="btn-almacenes">
											Ver Almacenes({cantidades[persona.idCompany]})
										</Link>
									}
									{(!cantidades[persona.idCompany] || cantidades[persona.idCompany] == 0) &&
										<Link to={'/host/gestion/personas/'+persona.idCompany+'/almacenes/nuevo'} className="btn-almacenes">
											Agregar Almacén
										</Link>
									}
								</div>
							</div>
						)
					})}

					{personas?.length === 0 &&
						<div className={vistaLista ? "empresa-list-item empresa-list-empty" : "empresa-card empresa-card-empty"}>
							<div className={vistaLista ? "empresa-list-icon" : "empresa-icon"}>
								<img src={SinEmpresa} alt="Sin empresa"/>
							</div>
							<div className={vistaLista ? "empresa-list-info" : "empresa-info"}>
								<h3 className={vistaLista ? "empresa-list-nombre" : "empresa-nombre"}>Sin Empresa Registrada</h3>
							</div>
							<div className={vistaLista ? "empresa-list-actions" : "empresa-actions"}>
								<Link to='/host/gestion/personas/nueva' className="btn-almacenes">
									Agregar Empresa
								</Link>
							</div>
						</div>
					}
				</div>
			</div>
		);
}

export default Host;